import Wrap from "../../../components/wrap";

export default function Models() {

    return (
        <section className="models-section bg-models-advertisers">
            <Wrap>
                <div>
                    <h2 className="section-title bg-models-advertisers">Supports All Ad Formats</h2>
                    <p className="section-desc bg-models-advertisers text-black">Optimizes and delivers solutions for Display, In-Stream video, Out-Stream, and Native ad formats.</p>
                </div>
                <p className="section-desc bg-models-advertisers text-black">AdMatic integrates ad delivery for display and video, multi-integration capabilities, and outstream functionality into a single platform, thereby creating a new framework for programmatic buyers to monetize their inventory.</p>
            </Wrap>
        </section>
    )
}
